<div class="charger-section">
  <div class="breadcrumb">
    <span > <a [routerLink]="['/home/dashboard']">Dashboard</a></span>
    <mat-icon>keyboard_arrow_right</mat-icon>
    <span class ='current'>Chargers</span>
  </div>
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label class="label">Search</mat-label>
      <input matInput placeholder="Search">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    <button class="add-charger-button" *ngIf="selectedTabIndex === 0" (click)="addCharger()">
      <mat-icon>add_circle</mat-icon>
      Add Charger
    </button>
    <button class="add-charger-button" *ngIf="selectedTabIndex === 1" (click)="openAddTariffDialog()">
      <mat-icon>add_circle</mat-icon>
      Add Tariff Plan
    </button>
    <button class="add-charger-button" *ngIf="selectedTabIndex === 2">
      <mat-icon>add_circle</mat-icon>
      Add Charger Owner
    </button>
  </div>
  <div class="tabs-and-count-section">
    <mat-tab-group class="tabs-section" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Chargers"></mat-tab>
      <mat-tab label="Tariff Plans"></mat-tab>
      <mat-tab label="Charger Owners"></mat-tab>
    </mat-tab-group>
  </div>

  <!-- Chargers Table -->
  <div class="table-section" *ngIf="selectedTabIndex === 0">
    <table mat-table [dataSource]="chargersDataSource" matSort class="users-table">
      <ng-container matColumnDef="serialNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Serial Number</th>
        <td mat-cell *matCellDef="let element"> {{ element.serialNumber}}</td>
      </ng-container>
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef>Charger Model</th>
        <td mat-cell *matCellDef="let element"> {{ element.model}}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> City</th>
        <td mat-cell *matCellDef="let element"> {{ element.city }}</td>
      </ng-container>
      <ng-container matColumnDef="tariff">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tariff Rate</th>
        <td mat-cell *matCellDef="let element">Rs 18</td>
      </ng-container>
      <ng-container matColumnDef="connectors">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Connectors</th>
        <td mat-cell *matCellDef="let element"> Type_6_DC</td>
      </ng-container>
      <ng-container matColumnDef="chargerOwner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Charger Owner</th>
        <td mat-cell *matCellDef="let element"> Clean Electric</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element" >
          <span [ngClass]="{
            'status-badge-approved': element.status === 'Available',
            'status-badge-pending': element.status === 'Unavailable',
            'status-badge-rejected': element.status === 'Offline'
          }" class="status-badge">
            {{ element.status }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="viewChargerInfo()">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="chargerDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: chargerDisplayedColumns;"></tr>
    </table>
  </div>

  <!-- Tariff Plans Table -->
  <div class="table-section" *ngIf="selectedTabIndex === 1">
    <table mat-table [dataSource]="tariffDataSource" matSort class="users-table">
      <ng-container matColumnDef="tariffName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tariff Name</th>
        <td mat-cell *matCellDef="let element"> {{ element.tariffName }}</td>
      </ng-container>
      <ng-container matColumnDef="pricePerKwh">
        <th mat-header-cell *matHeaderCellDef>Price Per Kwh(Rs)</th>
        <td mat-cell *matCellDef="let element"> {{ element.pricePerKwh }}</td>
      </ng-container>
      <ng-container matColumnDef="sgst">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SGST(%)</th>
        <td mat-cell *matCellDef="let element"> {{ element.sgst }}</td>
      </ng-container>
      <ng-container matColumnDef="cgst">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CGST(%)</th>
        <td mat-cell *matCellDef="let element">{{ element.cgst }}</td>
      </ng-container>
      <ng-container matColumnDef="igst">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>IGST(%)</th>
        <td mat-cell *matCellDef="let element"> {{ element.igst }}</td>
      </ng-container>
      <ng-container matColumnDef="assignedTo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned to</th>
        <td mat-cell *matCellDef="let element"> {{ element.assignedTo }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tariffDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tariffDisplayedColumns;"></tr>
    </table>
  </div>

  <!-- Charger Owners Table -->
  <div class="table-section" *ngIf="selectedTabIndex === 2">
    <div class="empty-state">
      <mat-icon>business</mat-icon>
      <p>Charger owners data will be displayed here</p>
    </div>
  </div>

  <div class="pagination-section">
    <mat-paginator [length]="currentDataLength"
                   [pageSize]="10"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   aria-label="Select page">
    </mat-paginator>
  </div>
</div>

